import { apiRequest } from '../../../api/client';
import type { AppSettingsRead, AppSettingsUpdatePayload } from '../../../api/types';

// PARA-106, AC-4.
export async function fetchAppSettings(): Promise<AppSettingsRead> {
  return apiRequest<AppSettingsRead>('/admin/settings');
}

// PARA-106, AC-5/AC-6/AC-10.
export async function updateAppSettings(
  payload: AppSettingsUpdatePayload,
): Promise<AppSettingsRead> {
  return apiRequest<AppSettingsRead>('/admin/settings', {
    method: 'PUT',
    body: payload,
  });
}
